import { Action } from 'redux';

import { ChangeExtractRefreshSchedule } from '../../app/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';

export interface ChangeExtractRefreshScheduleAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function changeExtractRefreshSchedule(tasks: IExtractTaskInfo[]): ChangeExtractRefreshScheduleAction {
  return {
    type: ChangeExtractRefreshSchedule,
    tasks
  };
}
